export default {
  title: "Users",
  subtitle: "Manage user accounts and access",
  banCustomer: "Ban User",
  activateCustomer: "Activate User",
  addNew: "Add New User",
  createUser: "Create User",
  editUser: "Edit User",
  deleteUser: "Delete User",
  
  fields: {
    name: "Name",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email Address",
    phone: "Phone Number",
    username: "Username",
    password: "Password",
    confirmPassword: "Confirm Password",
    role: "Role",
    department: "Department",
    position: "Position",
    avatar: "Profile Picture",
    isActive: "Active",
    isVerified: "Verified",
    lastLogin: "Last Login",
    loginCount: "Login Count",
    status: "Status",
    notes: "Notes",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  placeholders: {
    firstName: "Enter first name",
    lastName: "Enter last name",
    email: "Enter email address",
    phone: "Enter phone number",
    username: "Enter username",
    password: "Enter password",
    confirmPassword: "Confirm password",
    department: "Enter department",
    position: "Enter position",
    notes: "Enter additional notes",
    name: "Name",
    role: "Role"
  },
  
  messages: {
    createSuccess: "User created successfully",
    createError: "Failed to create user",
    updateSuccess: "User updated successfully",
    updateError: "Failed to update user",
    deleteSuccess: "User deleted successfully",
    deleteError: "Failed to delete user",
    deleteConfirm: "Are you sure you want to delete this user?",
    statusConfirm: "Are you sure you want to {{action}} this user?",
    statusSuccess: "User {{action}}d successfully",
    statusError: "Failed to update user status",
    resetPasswordConfirm: "Are you sure you want to reset this user's password?",
    noUsers: "No users found",
    loadingUsers: "Loading users...",
    fetchError: "Failed to fetch users",
    passwordResetSuccess: "Password reset email sent",
    passwordResetError: "Failed to send password reset email"
  },
  
  validation: {
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    nameRequired: "Name is required",
    nameMinLength: "Name must be at least 2 characters",
    emailRequired: "Email address is required",
    emailFormat: "Please enter a valid email address",
    emailInvalid: "Please enter a valid email address",
    emailExists: "Email address already exists",
    usernameRequired: "Username is required",
    usernameMinLength: "Username must be at least 3 characters",
    usernameExists: "Username already exists",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 8 characters",
    passwordComplexity: "Password must include uppercase, lowercase, number, and special character",
    passwordTooEasy: "Password cannot be an easy password like 123456",
    passwordMatchesPhone: "Password cannot match the registered mobile number",
    passwordMatch: "Passwords do not match",
    phoneRequired: "Phone number is required",
    phoneFormat: "Please enter a valid phone number",
    roleRequired: "Role is required",
    fillAllFields: "Please fill in all required fields"
  },
  
  table: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    username: "Username",
    role: "Role",
    department: "Department",
    lastLogin: "Last Login",
    status: "Status",
    actions: "Actions"
  },
  
  statusOptions: {
    active: "Active",
    inactive: "Inactive",
    suspended: "Suspended",
    banned: "Banned",
    pending: "Pending"
  },
  
  actions: {
    resetPassword: "Reset Password",
    sendVerification: "Send Verification",
    activate: "Activate",
    deactivate: "Deactivate",
    suspend: "Suspend"
  },
  
  breadcrumbs: {
    users: "Users",
    create: "Create User",
    edit: "Edit User",
    view: "View User",
    profile: "User Profile"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index"
  },

  viewLogs: "View Logs",

  logs: {
    title: "User Logs",
    subtitle: "Activity logs for user #{{userId}}",
    timestamp: "Timestamp",
    level: "Level",
    message: "Message",
    requestUrl: "Request URL",
    exception: "Exception",
    noLogs: "No logs found for this user",
    fetchLogsError: "Failed to fetch user logs"
  }
};
